//引用AES源码js
import CryptoJS from 'crypto-js'

const iv = CryptoJS.enc.Utf8.parse('1234567890abcdef');//偏移量

function createNonceStr(){
  let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
  let nums="";
  for(let i=0;i<16;i++){//这里是几位就要在这里不改变
  let id = parseInt(Math.random()*61);
  nums+=chars[id];
  }
  return nums;
};

//解密方法
function AESDecrypt(key, data) {
    //加密选项
  let CBCOptions = {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };
  let decrypt = CryptoJS.AES.decrypt(
    data,
    CryptoJS.enc.Utf8.parse(key),
    CBCOptions
  );
  return CryptoJS.enc.Utf8.stringify(decrypt);
}

//加密方法
function AESEncrypt(form){
  const data = JSON.stringify(form)
  let key = createNonceStr();
    //加密选项
  let CBCOptions = {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };
  let decrypt = CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Utf8.parse(key),
    CBCOptions
  );
  return {
    data: decrypt.ciphertext.toString(CryptoJS.enc.Base64),
    key: key
  }
   
    // let srcs = CryptoJS.enc.Utf8.parse(word);
    // let key = createNonceStr()
    // console.log(srcs);
    // console.log(key);
    //CipherOption,加密的一些选项：
    //mode:加密模式，可取值（CBC,CFB,CTR,CTRGladman,OFB,ECB),都在CryptoJS.mode对象下
    //padding:填充方式，可取值（Pkcs7,Ansix923,Iso10126,ZeroPadding,NoPadding),都在CryptoJS.pad对象下
    //iv:偏移量，mode===ECB时，不需要iv
    //返回的是一个加密对象
    // let encrypted = CryptoJS.AES.encrypt(srcs,key,{
    //     iv:iv,
    //     mode:CryptoJS.mode.CBC,
    //     padding:CryptoJS.pad.Pkcs7
    // });
    //将结果进行base64加密
}

export {AESDecrypt,AESEncrypt}
